import React from 'react'

export const DashRnd = () => {
  return (
    <div>DashRnd</div>
  )
}
